import { render } from "./EquipmentTypeManage.vue?vue&type=template&id=4727c73e"
import script from "./EquipmentTypeManage.vue?vue&type=script&lang=js"
export * from "./EquipmentTypeManage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__